import axiosInstance from "auth/FetchInterceptor";

const { CHAT_API } = require("constants/ApiConstant");

const ChatService = {};

ChatService.SendMessage = function (data) {
  return axiosInstance.post(CHAT_API, data, {
    baseURL: process.env.REACT_APP_CHAT_URL,
  });
};

ChatService.GetMessages = function (data) {
  return axiosInstance.post(`${CHAT_API}/messages`, data, {
    baseURL: process.env.REACT_APP_CHAT_URL,
  });
};

ChatService.GetMembers = function (id) {
  return axiosInstance.get(`${CHAT_API}/members?RoomType=${id}`, {
    baseURL: process.env.REACT_APP_CHAT_URL,
  });
};

export default ChatService;
